module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech---BRIO-Video.8467d97b.webp";